import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const useAuthStore = create(
  devtools(
    persist(
      (set, get) => ({
        // Auth state
        username: null,
        token: null,
        companyId: null,
        companyName: null,
        agttp: null,
        user_type: null,
        accountype_temp: null,
        permissions: {},
        
        // Actions
        setAuthData: (authData) =>
          set(
            {
              username: authData.username,
              token: authData.token,
              companyId: authData.company_id,
              companyName: authData.company_name,
              agttp: authData.agttp,
              user_type: authData.user_type,
              accountype_temp: authData.accountype_temp,
            },
            false,
            "set-auth-data"
          ),

        setPermissions: (permissions) =>
          set({ permissions: permissions || {} }, false, "set-permissions"),
        
        setToken: (token) => set({ token }, false, "set-token"),

        updateUserType: (data) =>
          set(
            {
              agttp: data.agttp,
              user_type: data.user_type,
            },
            false,
            "update-user-type"
          ),
        
        clearAuthData: () =>
          set(
            {
              username: null,
              token: null,
              companyId: null,
              companyName: null,
              agttp: null,
              user_type: null,
              accountype_temp: null,
              permissions: {},
            },
            false,
            "clear-auth-data"
          ),
        
        // Utility getters
        getToken: () => get().token,
        getUsername: () => get().username,
        getCompanyId: () => get().companyId,
        getCompanyName: () => get().companyName,
        getAgttp: () => get().agttp,
        getUserType: () => get().user_type,
        getAccountypeTemp: () => get().accountype_temp,
        getPermissions: () => get().permissions || {},

        isAuthenticated: () => !!get().token,

        hasAccess: (moduleCode, minLevel = 10) => {
          const perms = get().permissions;
          if (!perms || Object.keys(perms).length === 0) return true;
          return (perms[moduleCode] || 0) >= minLevel;
        },

        getLevel: (moduleCode) => {
          const perms = get().permissions;
          if (!perms) return 0;
          return perms[moduleCode] || 0;
        },

        // Helper functions
        getUserTypeLabel: () => {
          const agttp = get().agttp;
          return agttp === 0 ? "Agent" : agttp === 1 ? "Trader" : "Unknown";
        },
      }),
      {
        name: "auth-storage",
        partialize: (state) => ({
          username: state.username,
          token: state.token,
          companyId: state.companyId,
          companyName: state.companyName,
          agttp: state.agttp,
          user_type: state.user_type,
          accountype_temp: state.accountype_temp,
          permissions: state.permissions,
        }),
      }
    ),
    {
      name: "auth-store", // Name for devtools
    }
  )
);

export default useAuthStore; 
